<!-- Navbar -->
<app-car-insurance-navbar></app-car-insurance-navbar>
<!--success content-->
<div class="flex flex-col items-center gap-80 self-stretch">
  <div class="flex flex-col items-center gap-20 w-full pt-[30px] pr-0 pb-[80px] pl-0 relative"
    (click)="hideBottomSheet()">

    <!-- Main Content -->
    <div class="flex flex-col items-center gap-[10px] w-full sm:w-[510px] h-auto sm:h-[453px] max-w-[800px] px-4">
      <img src="/png/Clip path group.svg" alt="Submitted Successfully"
        class="w-[110px] h-[110px] sm:w-[200px] sm:h-[200px]" />
      <h3 class="text-center text-[#F5375C] font-[manrope] text-[20px] sm:text-[28px] font-extrabold leading-normal">
        {{ 'Submitted Successfully!' | translate }}
      </h3>
      <p
        class="w-[90%] sm:w-full mx-auto text-center text-[#1B1B1B] font-[manrope] text-[12px] sm:text-[16px] font-normal leading-normal">
        {{ 'Thank you for your interest in our Car Insurance!...' | translate }}
      </p>
    </div>

    <!--Laptop screen-->
    <img src="/png/Frame 1597882382.svg"
      class="hidden sm:block w-[292.148px] h-[292.148px] bg-cover bg-no-repeat bg-center absolute mt-[360px] mr-[520px] -rotate-9" />
    <div
      class="hidden sm:flex w-[674px] p-[60px] justify-center items-center gap-8 rounded-[24px] bg-white shadow-[0_4px_24px_0_rgba(0,0,0,0.12)]">
      <div
        class="w-[180px] h-[180px] p-[16.364px] rounded-[12.273px] bg-[#FAFAFA] shadow-[0_2.045px_16.364px_0_rgba(0,0,0,0.16)] flex items-center justify-center">
        <img src="/png/QR.svg" alt="image"
          class="w-full h-full object-contain py-2 border-2 border-dashed border-black rounded-[12px]" /> </div>
      <div class="flex flex-col items-start gap-4 flex-1">
        <h3
          class="self-stretch text-[#121212] text-center font-[manrope] text-[32px] not-italic font-bold leading-[140%]">
          {{'Scan and Download'|translate}} </h3>
        <p
          class="self-stretch text-[#1B1B1B] text-center font-[manrope] text-[18px] not-italic font-normal leading-[140%]">
          {{'Get our app in seconds, Just scan the QR code to sign in'|translate}} </p>
      </div>
    </div> 

    <!-- Bottom Sheet Popup (Mobile only) -->
    <div *ngIf="showBottomSheet" class="fixed bottom-0 inset-x-0 sm:hidden z-50" (click)="$event.stopPropagation()">
      <!-- prevents closing when clicking inside -->
      <div class="w-full bg-white rounded-t-[30px] shadow-[0_8px_32px_0_rgba(0,0,0,0.25)] max-h-[90vh] overflow-y-auto"
        [ngClass]="showBottomSheet ? 'animate-slideUp' : 'animate-slideDown'">
        <div class="p-6 text-center relative">

          <!-- Top Handle -->
          <div class="w-12 h-1 bg-gray-400 rounded-full mx-auto mb-4"></div>

          <!-- Image -->
          <img src="/png/Frame 1597882382.svg" class="w-[220px] h-[220px] bg-cover bg-center mx-auto -rotate-9" />

          <!-- Title -->
          <h3 class="text-[16px] font-bold text-[#030E21] text-center font-[Manrope] mb-2">
            {{ 'Download App' | translate }}
          </h3>

          <!-- Subtitle -->
          <p class="text-[13px] font-normal leading-[140%] text-[#3A3839] text-center font-[Manrope] mb-6">
            {{ 'Get started in seconds. Tap below to install and sign in' | translate }}
          </p>

          <!-- Button -->
          <div class="flex justify-center">
            <a href="https://livwell.app.link/90iNAlNL2Jb?_p=c11130dc9d037af3e30387fc" target="_blank"
              rel="noopener noreferrer" class="flex items-center justify-center gap-2 px-10 py-3 rounded-full bg-[#2AD189]
                      text-black font-[Manrope] text-[16px] font-bold leading-[120%]
                      shadow-lg hover:bg-[#24b777] transition">
              {{ 'Download App' | translate }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--footer-->
<div class="hidden sm:block ">
  <app-car-insurance-footer></app-car-insurance-footer>
</div>